<template>
  <div class="login-normal-container container-first-login">
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 first-login-container">
        <div class="errors">
          <div class="" ref="alert"></div>
        </div>
        <div class="first-login-title-container">
          <div class="first-login-title">{{$t("message.login_first_login_title")}}</div>
          <div class="first-login-subtitle">{{$t("message.login_first_login_subtitle")}}</div>
        </div>
        <form name="form.firstLogin" class="first-login-form-container" action @submit.prevent="passwordChange()">
          <div class="password-repeat-container">
              <div class="popover__wrapper">
                <a href="#">
                  <div class="eye-input-container">
                    <div class="">
                      <zt-tooltip
                        position="right"
                        color="dark-300"
                        data-vs-tooltip="tooltip-pass-policies"
                        outlined
                        shadow
                      >
                        <div slot="body" class="p-3">
                          <PasswordPolicie :pass-policies="policies" />
                        </div>
                        <div class="first-login-fields" style="width: 21vw;">
                          <input type="password" class="input-text" name="password" id="firstLogin.password"
                            v-model="form.firstLogin.password" v-validate="'required'" placeholder=" " data-vs-input="input-first-login-pass">
                          <label v-if="$browserDetect.isIE" class="username-password-label-IE"
                            for="firstLogin.password">{{$t('message.login_first_login_password_field_label')}}</label>
                          <label v-else class="username-password-label"
                            for="firstLogin.password">{{$t('message.login_first_login_password_field_label')}}</label>
                        </div>
                      </zt-tooltip>
                    </div>
                    <div v-if="(!$browserDetect.isIE) && (!$browserDetect.isEdge)" class="eye"
                      @click="showPassword('firstLogin.password')"></div>
                  </div>
                  <div class="m--font-danger" v-show="errors.has('password')">
                    {{$t("message.login_first_login_required_field")}}</div>
                </a>
              </div>
            <div class="">
              <div class="eye-input-container">
                <div class="first-login-fields">
                  <input type="password" class="input-text" name="confirm" id="firstLogin.confirm"
                    v-model="form.firstLogin.confirm" v-validate="'required'" placeholder=" " data-vs-input="input-first-login-confirm-pass">
                  <label v-if="$browserDetect.isIE" class="username-password-label-IE" for="firstLogin.confirm">{{$t('message.login_first_login_repeat_password_field_label')}}</label>
                  <label v-else class="username-password-label" for="firstLogin.confirm">{{$t('message.login_first_login_repeat_password_field_label')}}</label>
                </div>
                <div v-if="(!$browserDetect.isIE) && (!$browserDetect.isEdge)" class="eye" @click="showPassword('firstLogin.confirm')"></div>
              </div>
              <div class="m--font-danger" v-show="errors.has('confirm')">
                {{$t("message.login_first_login_required_field")}}</div>
            </div>
          </div>
          <div class="first-login-mail-container">
            <div class="first-login-notification-container" style= "margin: 1.5vh 0;">
              <div class="">
                <label class="m-checkbox first-login-label-checkbox">
                  <input type="checkbox" v-model="form.firstLogin.hasMail" @click="notificationMail" data-vs-checkbox="checkbox-notification-mail" />
                  {{$t("message.login_first_login_no_email_label")}}
                  <span class="first-login-checkbox"></span>
                </label>
              </div>
            </div>
            <div class="" style="display: flex;
              flex-direction: column;">
              <div class="first-login-fields">
                <input type="text" class="input-text" name="mail" id="form.firstLogin.mail"
                  v-model="form.firstLogin.mail" v-validate="form.firstLogin.hasMail ? '' : 'required|email'"
                  placeholder=" " data-vs-input="input-first-login-mail">
                <label v-if="$browserDetect.isIE" class="username-password-label-IE" for="form.firstLogin.mail">{{$t('message.ei_titleList_text_2_2')}}</label>
                <label v-else class="username-password-label" for="form.firstLogin.mail">{{$t('message.ei_titleList_text_2_2')}}</label>
              </div>
              <div class="m--font-danger" v-show="errors.has('mail')">
                <p v-for="(error, index) in errors.collect('mail')" :key="index">{{ error }}</p>
              </div>
              <!-- <span class="">{{$t("message.login_first_login_email_field_help_text")}}</span> -->
            </div>
            <div class="" style="margin: 3.5vh 0;">
              <div class="">
                <label class="m-checkbox first-login-label-checkbox">
                  <input type="checkbox" name="terms" v-validate="'required'" data-vs-checkbox="checkbox-first-login-terms-conditions" />
                  <a
                    :href="termsAndConditionsUrl"
                    class="terms-link" 
                    target="_blank"
                  >
                    {{ $t('message.first_login_terms_conditions') }}
                  </a>
                  <span class="first-login-checkbox"></span>
                </label>
              </div>
              <div class="m--font-danger" v-show="errors.has('terms')">
                <p v-for="(error, index) in errors.collect('terms')" :key="index">{{ error }}</p>
              </div>
            </div>
            <div class="first-login-buttons-container">
              <div class="">
                <input type="button" id="m_login_first_login_cancel" class="btn btn-secondary btn-first-login"
                  :value="$t('message.login_go_back')"
                  data-vs-button="button-first-login-auth-login"
                  @click="clickAuthLogin" />
              </div>
              <div class="">
                <input v-if="buttonLoginDisable" type="submit" id="m_login_first_login_submit" class="btn btn-primary btn-first-login"
                  :value="$t('message.login_send')" />
                <input v-else id="m_login_first_login_submit" value="Cargando" class="btn btn-primary btn-first-login"  disabled />

              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-lg-6 col-md-6 mobile-hide desktop-show-logo">
          <div v-if="$browserDetect.isChrome" class="logo-desktop"></div>
        <div v-else>
          <img :src="`${baseUrl}assets/images/background-login.png`" class="logo-desktop-noChrome" />
        </div>
      </div>
  </div>
</template>

<script>
import { Vue } from "vue-property-decorator";
import PasswordPolicie from "@/components/generics/PasswordPolicie.vue";
import User from "../../apiClient/User";
import Alert from "../../components/generics/Alert.vue";


export default {
  components: {
    PasswordPolicie,
    Alert
  },
  props: {
    token: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    policies: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      buttonLoginDisable: true,
      showPass: false,
       form: {
        firstLogin: {
          token: this.token,
          password: '',
          confirm: '',
          hasMail: false,
          mail: this.email
        }
      },
      baseUrl: process.env.VUE_APP_BASE
    }
  },
  created(){
    this.user = new User();
  },
  methods: {
    clickAuthLogin(){
      this.$emit('clickAuthLogin', true)
    },
    showPassword(id){
      if (this.showPass){
        this.showPass = false;
        document.getElementById(id).setAttribute("type", "password");
      }
      else{
        this.showPass = true;
        document.getElementById(id).setAttribute("type", "text");
      }
    },
    changeStateReload(){
      this.buttonLoginDisable = !this.buttonLoginDisable;
    },
    passwordChange() {
    this.alertMoment = JSON.parse(localStorage.getItem("alertMoment"));
    this.$validator.validate().then(result => {
      let params = [];
      let email = this.form.firstLogin.mail ? this.form.firstLogin.mail : "";
      params.push(email);
      params.push(this.form.firstLogin.token);
      params.push(this.form.firstLogin.password);
      params.push(this.form.firstLogin.confirm);
      if(result){
        this.changeStateReload()
        this.user.resetpass("save", ...params).then(res => {
          if (res.data.status === "success") {
            swal({
              type: "success",
              title: res.data.results.data[0],
              showConfirmButton: true,
              confirmButtonText: "Aceptar"
            }).then(result => {
              _.mapValues(this.form.firstLogin, _.constant(null));
              this.$validator.reset();
              this.$emit('clickAuthLogin', true)
              this.changeStateReload()
            });
          } else {
            const {
              response: { data }
            } = res;
            if (this.alertMoment) {
              this.errorMessage(data.results.data[0]);
            }
          }
        })
        .catch(error => {
          const {
            response: { data }
          } = error;
          if (this.alertMoment) {
            this.errorMessage(data.results.data[0]);
          }
          this.changeStateReload()
        });
      }
    });
  },
  errorMessage(msg){
      const ComponentClass = Vue.extend(Alert)
      const instance = new ComponentClass({propsData: { role: 'danger', title: 'Error', message: this.$t(msg) }}).$mount();
      this.$refs.alert.appendChild(instance.$el);
  },
  notificationMail(event) {
      const mensaje = this.$t("message.login_mail");
      if (event.target.checked) {
        (document.getElementById("form.firstLogin.mail")).disabled = true;
        this.form.firstLogin.mail = null;
        swal("", mensaje);
      }
      else{
        (document.getElementById("form.firstLogin.mail")).disabled = false;
      }
    }
  },
  computed: {
    termsAndConditionsUrl() {
      if(this.$store.state.profile.pais === 'BR') {
        return 'https://community.test.com/t5/Sabias-que/POLITICA-DE-PRIVACIDAD-DE-LA-PLATAFORMA-TEST/ta-p/727913'
      }
      return 'https://community.test.com/t5/Sabias-que/POLITICA-DE-PRIVACIDAD-DE-LA-PLATAFORMA-TEST/ta-p/567941'
    }
  }
}
</script>
<style scoped lang="scss">
  @import "./login.scss";
</style>